module.exports = __webpack_public_path__ + "static/media/invitere.6f5feb10.m4a";